module.exports = __webpack_public_path__ + "img/freight_yard4_3.2f70c66f.png";